var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9108 1.72846C12.4374 1.20184 13.2912 1.20184 13.8178 1.72846L14.7714 2.68199C15.298 3.20861 15.298 4.06243 14.7714 4.58906L9.36803 9.9924C9.16171 10.1987 8.89405 10.3326 8.60521 10.3738L6.60279 10.6599C6.15781 10.7234 5.7764 10.342 5.83996 9.89705L6.12602 7.89463C6.16729 7.60579 6.30112 7.33812 6.50744 7.13181L11.9108 1.72846Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1663 8.00016V12.0002C15.1663 13.4729 13.9724 14.6668 12.4997 14.6668H4.49967C3.02692 14.6668 1.83301 13.4729 1.83301 12.0002V4.00016C1.83301 2.5274 3.02692 1.3335 4.49967 1.3335H8.49967M10.9572 2.682C10.9572 2.682 10.9572 3.63553 11.9108 4.58906C12.8643 5.54259 13.8178 5.54259 13.8178 5.54259M6.60279 10.6599L8.60521 10.3738C8.89405 10.3325 9.16171 10.1987 9.36803 9.9924L14.7714 4.58906C15.298 4.06244 15.298 3.20861 14.7714 2.68199L13.8178 1.72846C13.2912 1.20184 12.4374 1.20184 11.9108 1.72846L6.50744 7.13181C6.30112 7.33812 6.16729 7.60579 6.12602 7.89463L5.83996 9.89705C5.7764 10.342 6.15781 10.7234 6.60279 10.6599Z",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImg);
export default __webpack_public_path__ + "static/media/Edit_Img.9c0f69ee8523614b066813239e234288.svg";
export { ForwardRef as ReactComponent };